import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css'; // Importa los estilos CSS para el modal

/**
 * @typedef {object} ModalProps
 * @property {React.ReactNode} children - Los nodos React que se renderizarán dentro del modal.
 * @property {boolean} isOpen - Indica si el modal debe estar visible.
 * @property {() => void} onClose - Función que se llama cuando el usuario quiere cerrar el modal.
 */

/**
 * Componente Modal genérico que utiliza React Portals para renderizar contenido fuera de la jerarquía del DOM.
 * @param {ModalProps} props
 */
const Modal = ({ children, isOpen, onClose }) => {
  const [modalRoot, setModalRoot] = useState(null);

  useEffect(() => {
    const rootElement = document.getElementById('modal-root');
    setModalRoot(rootElement);

    if (!rootElement) {
      console.error(
        "No se encontró el elemento con id 'modal-root'. Asegúrate de crear un div con este ID en tu archivo principal (App.js)."
      );
    }
  }, []);

  if (!isOpen || !modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="modal-overlay modal-container" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-modal-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
